var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0H0.5V92.42H139.13V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.13 38.46V53.96H76.6V92.42H63.03V53.96H0.5V38.46H63.03V0H76.6V38.46H139.13Z",
    fill: "#CE1417"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.29 0H59.5V30.47L13.29 0ZM80.13 0H126.35L80.13 30.47V0ZM139.13 9.47L101.53 34.25H139.13V9.47ZM101.53 58.17H139.13V82.96L101.53 58.17ZM126.35 92.42L80.13 61.96V92.42H126.35ZM0.5 58.17H38.1L0.5 82.96V58.17ZM59.5 61.96L13.29 92.42H59.5V61.96ZM38.1 34.25L0.5 9.47V34.25H38.1Z",
    fill: "#233C90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.11 34.25L0.5 6.15995V0.449951L51.78 34.25H43.11Z",
    fill: "#CE1417"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 58.88L8.62 92.42H0.5V92.06L51.91 58.17H59.5V58.88Z",
    fill: "#CE1417"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.13 0.67L88.1899 34.25H80.1299V33.85L131.47 0H139.13V0.67Z",
    fill: "#CE1417"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.13 91.73L88.22 58.17H96.88L139.13 86.02V91.73Z",
    fill: "#CE1417"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/Flag_EN.f616b7c271cf3713b834a169a1a1190a.svg";
export { ForwardRef as ReactComponent };